import { SectionError } from "~/components/company/section-error";
import { FinancialsTab } from "~/components/company/tabs/financials-tab";
import { authHeadersFromRequest } from "~/lib/auth-headers.server";
import {
	companyCanonicalUrl,
	companyFromMatches,
	companyNotFoundMeta,
	companySocialMeta,
	fetchCompanySection,
	parseIcoSlug,
} from "~/lib/company-profile";
import { envConfig } from "~/lib/env-validation";
import { generateMetaTags } from "~/lib/seo";
import type { FinancialsSummaryResponse } from "~/types/financials";
import type { Route } from "./+types/finance";

export async function loader({ params, request }: Route.LoaderArgs) {
	const ico = parseIcoSlug(params.icoSlug);

	const headers = await authHeadersFromRequest(request);
	const summary = await fetchCompanySection<FinancialsSummaryResponse>(
		`${envConfig.apiBaseUrl}/companies/${ico}/financials/summary`,
		headers,
	);

	return { summary };
}

export function meta({ data: loaderData, matches }: Route.MetaArgs) {
	const company = companyFromMatches(matches);
	if (!company) return companyNotFoundMeta();

	return generateMetaTags({
		...companySocialMeta(company),
		title: `Tržby a hospodářské výsledky – ${company.name} | FirmIndex`,
		description: `Finanční výkazy, tržby, zisk a hospodářské výsledky firmy ${company.name} (IČO: ${company.ico}) z účetních závěrek.`,
		canonical: companyCanonicalUrl(company, "finance"),
		noindex: !loaderData?.summary || loaderData.summary.years.length === 0,
	});
}

export default function CompanyFinanceRoute({ loaderData }: Route.ComponentProps) {
	if (!loaderData.summary) {
		return <SectionError message="Nepodařilo se načíst finanční data." />;
	}
	return <FinancialsTab summary={loaderData.summary} />;
}
